import { Container } from '@mui/material';
import { AddPatient } from 'components/templates';

export const AddPatientView = () => {
  return (
    <Container>
      <AddPatient />
    </Container>
  );
};
